import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, Clock } from "lucide-react";
import PublicShell from "@/components/public/PublicShell";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Skeleton } from "@/components/ui/skeleton";
import { Loader2 } from "lucide-react";
import api from "@/lib/api";

export function Blog() {
    const [posts, setPosts] = useState(null);
    useEffect(() => { api.get("/blog").then((r) => setPosts(r.data)).catch(() => setPosts([])); }, []);
    return (
        <PublicShell>
            <section className="section-pad grid-bg">
                <div className="container-page">
                    <p className="overline">Resources & Insights</p>
                    <h1 className="mt-3 font-heading text-4xl sm:text-5xl font-extrabold tracking-tight">Practical reads on digital & AI skills</h1>
                </div>
            </section>
            <section className="pb-24">
                <div className="container-page grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {posts === null
                        ? Array.from({ length: 3 }).map((_, i) => <Skeleton key={i} className="h-80 rounded-2xl" />)
                        : posts.map((p) => (
                            <Card key={p.slug} data-testid={`blog-card-${p.slug}`} className="group overflow-hidden border-border/70 hover:shadow-xl transition-all">
                                <Link to={`/resources/${p.slug}`}>
                                    <img src={p.cover} alt={p.title} className="h-44 w-full object-cover" />
                                    <div className="p-6">
                                        <div className="flex items-center gap-3 text-xs text-foreground/50">
                                            <Badge variant="secondary" className="rounded-full">{p.category}</Badge>
                                            <span className="flex items-center gap-1"><Clock className="h-3.5 w-3.5" /> {p.read_time}</span>
                                        </div>
                                        <h3 className="mt-3 font-heading text-lg font-bold group-hover:text-primary transition-colors">{p.title}</h3>
                                        <p className="mt-2 text-sm text-foreground/60 line-clamp-2">{p.excerpt}</p>
                                    </div>
                                </Link>
                            </Card>
                        ))}
                </div>
            </section>
        </PublicShell>
    );
}

export function BlogPost() {
    const { slug } = useParams();
    const [p, setP] = useState(null);
    const [nf, setNf] = useState(false);
    useEffect(() => { api.get(`/blog/${slug}`).then((r) => setP(r.data)).catch(() => setNf(true)); }, [slug]);
    if (nf) return <PublicShell><div className="container-page section-pad text-center"><h1 className="font-heading text-2xl font-bold">Article not found</h1></div></PublicShell>;
    if (!p) return <PublicShell><div className="min-h-[60vh] grid place-items-center"><Loader2 className="h-8 w-8 animate-spin text-primary" /></div></PublicShell>;
    return (
        <PublicShell>
            <article className="container-page py-14 max-w-3xl">
                <Link to="/resources" className="inline-flex items-center text-sm text-foreground/60 hover:text-primary mb-6"><ArrowLeft className="mr-1 h-4 w-4" /> All Resources</Link>
                <Badge variant="secondary" className="rounded-full">{p.category}</Badge>
                <h1 className="mt-4 font-heading text-3xl sm:text-4xl font-extrabold tracking-tight">{p.title}</h1>
                <p className="mt-3 text-sm text-foreground/50">By {p.author} · {p.read_time}</p>
                <img src={p.cover} alt={p.title} className="mt-8 rounded-2xl w-full object-cover aspect-[16/9]" />
                <p className="mt-8 text-lg text-foreground/80 leading-relaxed">{p.excerpt}</p>
                <p className="mt-6 text-foreground/70 leading-relaxed whitespace-pre-line">{p.body}</p>
            </article>
        </PublicShell>
    );
}
